import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, Optional, Self } from '@angular/core';
import { FormControl, NgControl } from '@angular/forms';
import { MessageTypeEnum, SnackbarService } from '@fleet-beat/core';
import * as moment from 'moment';
import { SimpleField } from '../../abstracts/simple-field';
import { UploadFileTypeEnum } from '../../enums/type-file.enum';
import { DocumentUploadEditorModel } from '../../models/editor-upload.model';
import { FileFieldConfig } from '../../models/fields/file-field-config.model';

@Component({
  selector: 'fb-upload-file-list-field',
  templateUrl: './upload-file-list-field.component.html',
  styleUrls: ['./upload-file-list-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadFileListFieldComponent extends SimpleField<File[] | DocumentUploadEditorModel[]> {
  @Input() caption: string;
  @Input() config?: FileFieldConfig;

  date: string = moment(new Date()).format('MM/DD/YYYY');
  fileControl: FormControl = new FormControl();
  files: File[];
  defaultFileTypes?: string[] = [
    UploadFileTypeEnum.JPEG,
    UploadFileTypeEnum.JPG,
    UploadFileTypeEnum.PNG,
    UploadFileTypeEnum.SVG,
    UploadFileTypeEnum.PDF,
  ];

  constructor(
    protected override changeDetectorRef: ChangeDetectorRef,
    @Optional() @Self() protected override ngControl: NgControl,
    private snackBarService: SnackbarService,
  ) {
    super(changeDetectorRef, ngControl);

    this.valueSubject.subscribe((res: File[] | DocumentUploadEditorModel[]) => {
      this.files = res as File[];
    });
  }

  onDeleteFromList(i: number): void {
    this.files = this.files.filter((item: File, index: number) => index !== i);
    this.value = this.files;
  }

  onAddFile(files: FileList): void {
    if (!files) {
      return;
    }

    let fileArray: File[] = [];
    for (const i in files) {
      fileArray.push(files[i]);
    }

    fileArray = fileArray.slice(0, fileArray.length - 2);
    const fileNotValid: boolean = fileArray.some((file: File) => {
      if (!(this.config.availableFileTypes || this.defaultFileTypes).includes(file.type)) {
        this.snackBarService.show({ message: 'Wrong file type', type: MessageTypeEnum.ERROR });
        return true;
      }

      if (file.size > 1000000) {
        this.snackBarService.show({ message: 'The image size is too large', type: MessageTypeEnum.ERROR });
        return true;
      }
      return false;
    });

    if (fileNotValid) return;

    this.files = fileArray;
    this.value = this.files;
  }
}
